<!-- Nota de la fecha límite (en la parte superior) -->
<div class="note">
  Fecha límite para hacer el registro 12 de Octubre.
</div>

<div class="banner-container">
  <img src="../../assets/img/Banner Carrera.jpeg" alt="Banner Carrera Aniversario">
</div>

<div class="title">
  Registro Carrera Aniversario
</div>
<div class="register-container" [formGroup]="registroForm">
  <div class="row">
    <div class="column column-full">
      <label for="nombreCompleto">Nombre Completo*:</label>
      <input type="text" id="nombreCompleto" formControlName="nombreCompleto">
      <div *ngIf="registroForm.get('nombreCompleto').invalid && registroForm.get('nombreCompleto').touched" class="error">Nombre Completo es requerido.</div>
    </div>
    <div class="column column-full">
      <label for="fechaNacimiento">Fecha de Nacimiento*:</label>
      <mat-form-field appearance="fill">
        <input matInput [matDatepicker]="picker" formControlName="fechaNacimiento">
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
      </mat-form-field>
      <div *ngIf="registroForm.get('fechaNacimiento').invalid && registroForm.get('fechaNacimiento').touched" class="error">Fecha de Nacimiento es requerida.</div>
    </div>
    <div class="column column-full">
      <label for="talla">Talla*:</label>
      <select id="talla" formControlName="talla">
        <option value="" disabled selected>Seleccione una talla</option>
        <option value="Ch">Ch</option>
        <option value="M">M</option>
        <option value="L">L</option>
        <option value="XL">XL</option>
        <option value="XXL">XXL</option>
      </select>
      <div *ngIf="registroForm.get('talla').invalid && registroForm.get('talla').touched" class="error">Talla es requerida.</div>
    </div>
    <div class="column column-full">
      <label for="categoria">Categoría*:</label>
      <select id="categoria" formControlName="categoria" (change)="onCategoriaChange($event)">
        <option value="" disabled selected>Seleccione una categoría</option>
        <option value="160">Colegiados y estudiantes $ 300</option>
        <option *ngIf="!isSessionActive" value="161">Público en General $ 350</option>
        <option value="162">Caminata recreativa $ 250</option>
      </select>
      <div *ngIf="registroForm.get('categoria').invalid && registroForm.get('categoria').touched" class="error">Categoría es requerida.</div>
    </div>
    <div class="column column-full">
      <label for="correoElectronico">Correo Electrónico*:</label>
      <input type="email" id="correoElectronico" formControlName="correoElectronico">
      <div *ngIf="registroForm.get('correoElectronico').invalid && registroForm.get('correoElectronico').touched" class="error">Correo Electrónico es requerido y debe ser válido.</div>
    </div>
    <div class="column column-full">
      <label for="telefono">Teléfono*:</label>
      <input type="tel" id="telefono" formControlName="telefono">
      <div *ngIf="registroForm.get('telefono').invalid && registroForm.get('telefono').touched" class="error">Teléfono es requerido.</div>
    </div>
    <div class="column column-full">
      <label>Tipo de Pago*:</label>
      <div class="radio-group">
        <label>
          <input type="radio" name="tipoDePago" formControlName="tipoDePago" value="Efectivo" (change)="onTipoDePagoChange($event)"> Pago en el Colegio (En oficinas del CAT)
        </label>
        <label>
          <input type="radio" name="tipoDePago" formControlName="tipoDePago" value="Linea" (change)="onTipoDePagoChange($event)"> Pago en Línea
        </label>
      </div>
      <div *ngIf="registroForm.get('tipoDePago').invalid && registroForm.get('tipoDePago').touched" class="error">Tipo de Pago es requerido.</div>
    </div>
    <div class="column column-full">
      <button class="register-button" (click)="registrarse()">Registrarse</button>
    </div>
  </div>

  <!-- Nota de campos obligatorios (en la parte inferior dentro de la tarjeta) -->
  <div class="fields-required">
    * Campos obligatorios
  </div>
</div>

<style>
  .note {
    width: 100%;
    padding: 10px 20px;
    background-color: #f0f0f0;
    border-left: solid #007bff;
    font-size: 1.2em;
    margin-bottom: 20px;
    box-sizing: border-box;
  }

  .fields-required {
    font-size: 0.8em;
    color: #888;
    text-align: center;
    margin-top: 20px;
  }

  .banner-container {
    text-align: center; /* Centra la imagen horizontalmente */
    margin-bottom: 20px; /* Añade espacio debajo de la imagen */
  }

  .banner-container img {
    max-width: 100%; /* Ajusta la imagen al tamaño máximo del contenedor */
    height: auto; /* Mantiene la proporción de la imagen */
  }

  .error {
    color: red;
  }
</style>
